import $ from "jquery";
import capitalize from "lodash/capitalize";
import { observable, runInAction, toJS } from "mobx";
import queryString from "query-string";
import { heroState, liveTypes } from "./event-hero.js";

//? Observable state not used locally in "event-routing", though it could/should
//? be converted in the future. For now we just keep it updated so that other
//? processes can import it and react to the current active tab
export const tabState = observable({
  activeTab:
    document.querySelector(".js-toggle-tab.active")?.getAttribute("href") ??
    null,
});

(function () {
  // escape hatch
  if (!document.body.classList.contains("single-event")) return;

  const initialState = toJS(heroState);

  // ! Events

  // Managed History change (popState)
  window.onpopstate = (event) => {
    // no state obj: return to initial state
    if (!event.state) {
      $(".clip-freeform").css("display", "none");
      runInAction(() => {
        Object.assign(heroState, initialState);
      });
      return;
    }

    // no params? nothing to do
    if (!event.state?.params) {
      return;
    }

    const parms = new URLSearchParams(event.state.params);
    const target = parms.get("c") ?? null;
    if (target === "live") {
      playLive({ skipHistoryUpdate: true });
    } else if (target) {
      playClip(target, { skipHistoryUpdate: true });
    } else {
      // nothing to do
    }
  };

  // User clicks to play live
  $(document).on("click", '[href="#live"]', (e) => {
    e.preventDefault();
    playLive();
  });

  // User clicks to play a clip
  $(document).on("click", ".js-hero-swap", (e) => {
    e.preventDefault();
    const clipId = e.target.closest(".js-hero-swap").dataset.clipId;
    playClip(clipId);
  });

  // User clicks to switch tabs
  $(".js-toggle-tab").on("click", function (e) {
    e.preventDefault();

    if (!$(this).hasClass("active")) {
      const newTab = $(this).attr("href");
      switchTab($(newTab), $(this));
    }
  });

  // ! On Load
  // Initialize hash if present
  processHashOnLoad();

  // Initialize on a clip (if ?c param is present)
  // ? note: must be after the "click" listener on js-hero-swap is attached
  const { c: initialClipId } = queryString.parse(window.location.search);
  if (initialClipId === "live") {
    playLive();
  } else if (initialClipId) {
    playClip(initialClipId);
  }
})();

// ! Helpers / Functions

/**
 * Switch Tab
 * ? legacy function still using jquery
 *
 * @param {$element} tab (jQuery element)
 * @param {$element} tabLink (jQuery element)
 */
function switchTab(tab, tabLink) {
  /**
   * ? the tabState observable is not used in this file, though it could/should
   * ? until then, we are only using it outside of "event-routing" for any piece
   * ? of logic that depends on reacting to changes in the current tab
   */
  runInAction(() => {
    tabState.activeTab = tabLink.attr("href");
  });

  // Change active link class
  $(".event-sidebar-tab-link").removeClass("active");
  tabLink.addClass("active");

  // Hide old tab content
  $(".event-sidebar-tab-content").removeClass("active");

  // Reset hash in url
  clearHash();

  // Different behavior if home tab
  if (tabLink.attr("href") != "#tab-home") {
    // Add sidebar classes
    $("body").addClass("sidebar-open");
    $(".event-sidebar").addClass("open");

    // Show new tab content
    tab.addClass("active");
  } else if (window.innerWidth <= 960) {
    // Remove sidebar classes
    $("body").removeClass("sidebar-open");
    $(".event-sidebar").removeClass("open");

    // Scroll to top
    window.scrollTo(0, 0);
  }
}

/**
 * Unwrap the hero
 */
function unwrap() {
  runInAction(() => {
    const { type, title } = heroState.liveMedia;
    heroState.currentType = `live${capitalize(type)}`;
    heroState.caption = title;
  });
}

/**
 * Play the Live Media
 * @param {Object} options - Options object
 * @param {boolean} options.skipHistoryUpdate - If true, skip updating URL/history
 */
function playLive(options = { skipHistoryUpdate: false }) {
  if (heroState.mode !== "live") {
    return;
  }

  if (heroState.currentType === "plastic") {
    unwrap();
  } else {
    runInAction(() => {
      const { type, title, id } = heroState.liveMedia;
      heroState.currentType = ["youtube", "vimeo"].includes(heroState.liveType)
        ? `live${capitalize(type)}`
        : type;

      heroState.media = { type, id };
      heroState.caption = title;
      heroState.captionOverridedBySchedule = false;
    });
  }

  // update URL (for opengraph/sharing and history tracking)
  if (!options.skipHistoryUpdate) {
    setQueryStringParameter("c", "live");
  }

  // TODO: true clientside rendering on this
  // hide any clip freeform content
  $(".clip-freeform").css("display", "none");
}

/**
 * Play a Clip
 * @param {string|int} wpId - the wordpress ID of the clip
 * @param {Object} options - Options object
 * @param {boolean} options.skipHistoryUpdate - If true, skip updating URL/history
 */
function playClip(wpId, options = { skipHistoryUpdate: false }) {
  // Get clip metadata from clip link on the page
  //TODO - This should be refactored to where type and url are just single data-attrs in the markup
  const $clipLink = $(`[data-clip-id="${wpId}"]:not(.toast)`).last();
  let type, url;
  if ($clipLink.hasClass("type-audio")) {
    type = "audio";
    url = $clipLink.data("audio-url");
  } else if ($clipLink.hasClass("type-pdf")) {
    type = "pdf";
    url = $clipLink.data("pdf-url");
  } else if ($clipLink.hasClass("type-link")) {
    type = "link";
    url = $clipLink.data("link-url");
  } else if ($clipLink.hasClass("type-image")) {
    type = "image";
    url = $clipLink.data("image-url");
  } else {
    type = "video";
    url = $clipLink.data("video-url");
  }
  const title = $clipLink.data("title");

  // Error handling unsupported clip attempts
  if (!$clipLink.length || !type || !url) {
    console.warn("Tried to play a clip from outside the event page");
    return;
  }

  // Open PDF in new window if live video or if not on desktop
  let mql = window.matchMedia("screen and (max-device-width: 960px)");
  if (
    (type === "pdf" && mql.matches) ||
    (type === "pdf" && liveTypes.includes(heroState.currentType))
  ) {
    window.open(url);
    return;
  }

  // Open Link in new window always
  if (type === "link") {
    window.open(url);
    return;
  }

  // Update state
  runInAction(() => {
    heroState.caption = title;
    heroState.captionOverridedBySchedule = false;

    switch (type) {
      case "video":
        const videoType = url.includes("vimeo") ? "vimeo" : "youtube";
        heroState.currentType = videoType;
        heroState.media = {
          type: videoType,
          id: get_media_id_from_url(url),
          wpId,
        };
        break;
      case "audio":
        heroState.currentType = "wavesurfer";
        heroState.media = {
          type: "wavesurfer",
          id: url,
          wpId,
        };
        break;

      case "pdf":
      case "image":
        heroState.currentType = type;
        heroState.media = { type, id: url, wpId };

        // TODO info bar clientside render
        $(`.hero-infobar-${type}-button`).prop("href", url);
        break;
    }
  });

  // Update URL (for opengraph/sharing)
  if (!options.skipHistoryUpdate) {
    setQueryStringParameter("c", wpId);
  }

  // Show the freeform content
  // TODO clientside render
  $(".clip-freeform").css("display", "none");
  let clipFreeform = $(`.clip-freeform[data-clip-id="${wpId}"]`);
  if (clipFreeform.length) {
    clipFreeform.css("display", "block");
  }
}

/**
 * Process a Hash URL on load.
 *
 * Hashes control the live media and the sidebar tabs.
 *
 * These have their own event handlers when users click on things, but we need
 * a place to handle hashes on load. This is that.
 *
 * Note: technically hashes _used to_ control the live media, it is now controlled
 * by query params just like clips, but we are maintaining the #live links/urls
 * rather than refactoring all that. Basically the #live hash is forwarded into
 * the query param / managed history system.
 */
function processHashOnLoad() {
  const windowHash = window.location.hash;

  if (windowHash === "#live") {
    history.replaceState({ c: "live" }, "", `${location.pathname}?c=live`);
  }

  // Tabs
  if (windowHash && windowHash.includes("tab-")) {
    const tab = $(windowHash);
    const tabLink = $(".event-sidebar-tabs").find(
      '[href="' + windowHash + '"]'
    );
    switchTab(tab, tabLink);
  }

  // DM links switch to chat tab,
  const directoryTab = $('[data-tab-type="directory"]');
  if (directoryTab) {
    const chatTab = $('[data-tab-type="chat"]'),
      chatTabId = chatTab.attr("id"),
      chatTabLink = $(".event-sidebar-tabs").find(`[href="#${chatTabId}"]`),
      dirTabId = chatTab.attr("id"),
      dirTabLink = $(".event-sidebar-tabs").find(`[href="#${dirTabId}"]`);

    directoryTab.on("click", (e) => {
      if (e.target.closest("[data-dm-uid]")) {
        switchTab(chatTab, chatTabLink);
      }
    });

    // and user not available close button switches back to directory tab
    // ? needs time for lazy load
    if (chatTab) {
      $(window).load(function () {
        setTimeout(() => {
          const iframe = $('[data-tab-type="chat"]').find("iframe");
          iframe.contents().on("click", (e) => {
            // safari needs this timeout... no one knows why
            setTimeout(() => {
              if (e.target.closest(".not-available button")) {
                switchTab(directoryTab, dirTabLink);
              }
            }, 0);
          });
        }, 50);
      });
    }
  }
}

/**
 * Get remote "media id" from url
 * @param  {string} url a url of a remote media resource, includes "youtube" or "vimeo"
 * @returns {(string|Number)} the remote media id (vimeo is int, youtube is string)
 */
function get_media_id_from_url(url) {
  url = new URL(url);
  // ? only two types of video clips as of now: vimeo and youtube
  const type = url.host.includes("vimeo") ? "vimeo" : "youtube";
  const mediaId =
    type === "vimeo"
      ? parseInt(url.pathname.replace(/\D/g, "")) //?strip all non-digit chars
      : url.search.includes("v")
      ? url.href.substring(url.href.indexOf("=") + 1)
      : url.pathname.replace("/", "");
  return mediaId;
}

/**
 * Set Query String Parameter
 * @param {string}      name
 * @param {(string|null)} value - use null to delete value
 */
function setQueryStringParameter(name, value) {
  let params = new URLSearchParams(window.location.search);
  if (value === null) {
    params.delete(name);
  } else {
    params.set(name, value);
  }
  params = params.toString() ? `?${params.toString()}` : "";
  window.history.pushState(
    { params },
    document.title,
    decodeURIComponent(`${window.location.pathname}${params}`)
  );
}

/**
 * clearHash
 *
 * Removes hash from url, without leaving "#", refreshing the page, or mucking
 * with the history state object
 */
function clearHash() {
  history.replaceState(
    history.state,
    document.title,
    window.location.pathname + window.location.search
  );
}
